import { useLayoutEffect, useRef } from "react";
import { getFocusableElements } from "../../../common/utils/dom.ts";
import { ManageAssetWithLicense } from "../../../common/api/decimal/common-types/manageAssets.ts";
import AssetCard from "../common/cards/AssetCard.tsx";
import ErrorBoundary from "common/core-ui/ErrorBoundary.tsx";
import DefaultErrorAssetCard from "../common/cards/DefaultErrorAssetCard.tsx";

export default function LibraryAssetChunk({
  assets,
  focusFirstCard = true,
}: {
  assets: ManageAssetWithLicense[];
  focusFirstCard?: boolean;
}) {
  const firstCardRef = useRef<HTMLLIElement>(null);

  useLayoutEffect(() => {
    if (focusFirstCard && firstCardRef.current) {
      getFocusableElements(firstCardRef.current)[0]?.focus();
    }
  }, [focusFirstCard]);

  return assets.map((asset, i) => (
    <ErrorBoundary
      key={asset.manageAsset.vbid}
      errorContent={<DefaultErrorAssetCard />}
    >
      <AssetCard
        asset={asset}
        lazyLoad={i > 20}
        ref={i === 0 ? firstCardRef : undefined}
        hideOnReturn={true}
      />
    </ErrorBoundary>
  ));
}
